<p-inputgroup>
  <p-inputgroup-addon>$</p-inputgroup-addon>
  <p-inputnumber 
    type="text" 
    inputmode="numeric"
    [name]="name" 
    [id]="name + '-id'"
    fluid
    [(ngModel)]="value"
    [required]="isRequired" 
    [disabled]="isDisabled"
    [minFractionDigits]="2"
    (ngModelChange)="currencyInputChanged($event)"
  />
</p-inputgroup>
